import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map} from 'rxjs/operators';
import {of} from 'rxjs';
import {loadStreamStatuses, loadStreamStatusesFailure, loadStreamStatusesSuccess} from './stream-statuses.actions';
import {StreamStatusesService} from '../../services/api/stream-statuses/stream-statuses.service';
import {StreamStatus} from '../../services/api/stream-statuses/stream-status.model';


@Injectable()
export class StreamStatusesEffects {

  // noinspection JSUnusedGlobalSymbols
  loadStreamStatuses$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(loadStreamStatuses),
        concatMap(() => {
            return this.service.getAll()
              .pipe(
                map((data: StreamStatus[]) => loadStreamStatusesSuccess({data})),
                catchError((error: unknown) => of(loadStreamStatusesFailure({error})))
              );
          }
        )
      );
  });


  constructor(
    private readonly actions$: Actions,
    private readonly service: StreamStatusesService
  ) {
  }

}
